module.exports = __webpack_public_path__ + "static/img/h5_x2.abb609b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5_x2.png
// module id = K0mo
// module chunks = 1